import { TableTabConfig } from "../../config/tableConfig.types";
import { configToTableColumns } from "./configToTableColumns";
import { RelatedTableConfig } from "./TabbedTables.types";

/**
 * The single boundary between stored table config and the runtime, as
 * `configToStageRows` is for a page. The row filter is built here from the names config
 * holds; the columns come from `configToTableColumns`, shared with the list pages.
 */
export function tabConfigToTableConfig(
  tabs: TableTabConfig[]
): RelatedTableConfig[] {
  return tabs.map((tab) => ({
    key: tab.id,
    label: tab.label,
    entityName: tab.entityName,
    ...(tab.layout === undefined ? {} : { layout: tab.layout }),
    ...(tab.emptyMessage === undefined
      ? {}
      : { emptyMessage: tab.emptyMessage }),
    ...(tab.searchable === undefined ? {} : { searchable: tab.searchable }),
    ...(tab.filters === undefined ? {} : { filters: tab.filters }),
    ...(tab.searchFields === undefined
      ? {}
      : { searchFields: tab.searchFields }),
    ...(tab.pageSize === undefined ? {} : { pageSize: tab.pageSize }),
    ...(tab.fixedPageSize ? { fixedPageSize: true } : {}),
    ...(tab.flush ? { flush: true } : {}),
    ...(tab.sort?.primary
      ? {
          defaultSortKey: tab.sort.primary.key,
          defaultSortDir: tab.sort.primary.dir ?? "asc",
        }
      : {}),
    ...(tab.sort?.secondary
      ? {
          secondarySortKey: tab.sort.secondary.key,
          secondarySortDir: tab.sort.secondary.dir ?? "asc",
        }
      : {}),
    ...(tab.exclude
      ? {
          filterRow: (row: Record<string, unknown>) =>
            String(row[tab.exclude!.key]) !== tab.exclude!.equals,
        }
      : {}),
    columns: configToTableColumns(tab.columns),
  }));
}
